import { useState, useCallback } from "react";
import { toDriveDirectUrl } from "@/lib/utils";

interface TeamAvatarProps {
  foto?: string;
  nombre: string;
}

export default function TeamAvatar({ foto, nombre }: TeamAvatarProps) {
  const [hasError, setHasError] = useState(false);

  const handleError = useCallback(() => {
    setHasError(true);
  }, []);

  const handleLoad = useCallback(() => {
    setHasError(false);
  }, []);

  // Iniciales del nombre (primeras letras de cada palabra, máx 2)
  const iniciales = nombre
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  const url = toDriveDirectUrl(foto || "");

  return (
    <div
      className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden shrink-0 bg-masmed-gray-100 border border-masmed-gray-200 flex items-center justify-center relative"
    >
      {/* Placeholder con iniciales */}
      {(!url || hasError) && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-masmed-gray-100 text-primary text-lg md:text-xl font-bold select-none"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {iniciales || "?"}
        </div>
      )}

      {/* Imagen */}
      {url && (
        <img
          src={url}
          alt={nombre}
          className="w-full h-full object-cover object-top grayscale"
          onError={handleError}
          onLoad={handleLoad}
        />
      )}
    </div>
  );
}